module.exports = __webpack_public_path__ + "static/img/tu4.81e58f95.png";